import React, { ReactNode } from "react"
import "./ActButton.css"

interface Props {
    icon?: ReactNode | string
    label?: string
    btnClass?: string
    labelHidden?:boolean
    onClick: () => void
}

export default function ActButton(props: Props) {
    let { labelHidden, icon, btnClass, label, onClick} = props

    return (
        <button aria-label={label} className={`${btnClass} act-button`} onClick={onClick}>
            { icon && 
                <span className="act-button-icon">{icon}</span> 
            }
            { label && !labelHidden &&
                <span className="act-button-label">{label}</span> 
            }
        </button>
    )
}
